export default __webpack_public_path__ + "static/media/jibon-mobile-two.e59dff38.png";